<template>
  <page :manualInit="listState.init" :manualErr="listState.initErr" @reload="doInit">
    <template slot="pageAction">
      <div class="actionBlock" v-if="showStatusBtn">
        <v-tooltip bottom>
          <v-btn flat color="secondary" @click="lifeCycle = !lifeCycle" slot="activator">
            Status Overview
            <v-icon right>mdi-file-document-box</v-icon>
          </v-btn>
          <span>Status Overview</span>
        </v-tooltip>
      </div>
    </template>
    <div v-if="renderAppType">
      <v-subheader>
        {{labels.appID}}
      </v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorClaim', 'motorClaimQuery'])">
            <v-card :class="isMatchRoute('motorClaimListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'motorClaimListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelClaim', 'travelClaimQuery'])">
            <v-card :class="isMatchRoute('travelClaimListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelClaimListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireClaim', 'fireClaimQuery'])">
            <v-card :class="isMatchRoute('fireClaimListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireClaimListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <!-- <v-flex lg2 md3 xs6 v-if="checkAccess(['paClaim', 'paClaimQuery'])">
            <v-card :class="isMatchRoute('paClaimListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'paClaimListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex> -->
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoClaim', 'cargoClaimQuery'])">
            <v-card :class="isMatchRoute('cargoClaimListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'cargoClaimListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidClaim', 'maidClaimQuery'])">
            <v-card :class="isMatchRoute('maidClaimListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidClaimListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packageClaim', 'packageClaimQuery'])">
            <v-card :class="isMatchRoute('packageClaimListing') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'packageClaimListing' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
    <v-navigation-drawer temporary fixed clipped right app v-model="lifeCycle" width="400">
      <life-cycle query></life-cycle>
    </v-navigation-drawer>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'
import LifeCycle from './LifeCycle'
import { appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        appID: 'Application Type'
      },
      lifeCycle: false
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'claimListing') {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listState() {
      return this.$store.state.claims.listing
    },
    renderAppType() {
      if (this.isMatchRouteExact('claimListing') ||
        this.isMatchRouteExact('motorClaimListing') ||
        this.isMatchRouteExact('fireClaimListing') ||
        this.isMatchRouteExact('cargoClaimListing') ||
        this.isMatchRouteExact('travelClaimListing') ||
        this.isMatchRouteExact('paClaimListing') ||
        this.isMatchRouteExact('maidClaimListing') ||
        this.isMatchRouteExact('packageClaimListing')) {
        return true
      } else {
        return false
      }
    },
    showStatusBtn() {
      // We only want to show at query page
      if (this.isMatchRouteExact('claimListing') ||
        this.isMatchRouteExact('motorClaimListing') ||
        this.isMatchRouteExact('fireClaimListing') ||
        this.isMatchRouteExact('cargoClaimListing') ||
        this.isMatchRouteExact('travelClaimListing') ||
        this.isMatchRouteExact('paClaimListing') ||
        this.isMatchRouteExact('maidClaimListing') ||
        this.isMatchRouteExact('packageClaimListing')) {
        return false
      } else {
        return true
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('claimListInit')
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ],
  components: {
    LifeCycle
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";
</style>
